<template>
  <section class="tableofcontents">
    <h3 class="sr-only">Table of Contents</h3>
    <div id="toc">
      <ul>
        <li
          v-for="link of toc"
          :key="link.id"
          :class="{ toc2: link.depth === 2, toc3: link.depth === 3 }"
        >
          <NuxtLink :to="`#${link.id}`">{{ link.text }}</NuxtLink>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TableOfContents',
  props: ['toc'],
};
</script>

<style lang="scss" scoped>
.tableofcontents {
  margin: 0;

  .toc3 {
    margin-left: 1em;
  }
}
</style>
